<div class="plan-container">
  <div class="nav-bar">
    <div class="nav-bar-title">روزانه</div>
    <div
      *ngIf="planDataIsReady && hasDiet && !isBeforeStart"
      class="nav-bar-cheat-day img-holder"
      (click)="goToCheatDay()"
      id="cheat-day-box"
    >
      <img src="assets/plan/cheatdayEmoji.svg" style="width: 26px; top: 13px" />
      <div class="nav-bar-cheat-day-counter">{{ 2 - cheatDayCount }}</div>
    </div>
    <div class="nav-bar-refresh-holder" (click)="refresh()">
      <img src="assets/blog/refresh-icon.svg" />
    </div>
  </div>
  <div class="plan-holder">
    <app-plan-status
      [dataIsReady]="planDataIsReady"
      [input]="planStatusInput"
    ></app-plan-status>
    <div class="calendar-holder" id="calendar-box">
      <div class="calendar-previous-day img-holder" (click)="previousDay()">
        <img src="assets/plan/previousDay.png" />
      </div>
      <div
        *ngIf="planDataIsReady"
        class="calendar-current-day"
        (click)="openCalendar()"
      >
        <div class="calendar-current-day-img-holder">
          <img src="assets/plan/calendar.svg" />
        </div>
        <div class="calendar-current-day-title">{{ selectedDayTitle }}</div>
      </div>
      <ngx-skeleton-loader
        *ngIf="!planDataIsReady"
        [theme]="{
          top: '12px',
          right: 'calc( 50% - 50px )',
          height: '22px',
          width: '100px',
          position: 'absolute',
          'background-color': '#e8eaef'
        }"
      ></ngx-skeleton-loader>
      <div class="calendar-next-day img-holder" (click)="nextDay()">
        <img src="assets/plan/nextDay.png" />
      </div>
    </div>
    <app-battery
      class="plan-battery"
      [dataIsReady]="planDataIsReady"
      [status]="chartStatus"
      [maxCalorie]="dietCalorie"
      [exerciseCalories]="exerciseCalories"
    ></app-battery>
    <app-meals-table
      class="plan-meal-table"
      [dataIsReady]="planDataIsReady"
      [isPredefined]="isPredefined"
      [mealRatios]="mealRatios"
      [cheatDayCount]="cheatDayCount"
      [input]="dietDay"
      [dietId]="dietId"
      [dietCalorie]="dietCalorie"
    ></app-meals-table>
    <app-exercise-table
      *ngIf="exerciseIsReady"
      [calories]="exerciseCalories"
    ></app-exercise-table>
    <app-water
      class="plan-water"
      [weightDataIsReady]="weightDataIsReady"
      [date]="calendarShared.selectedDate"
    ></app-water>
    <app-plan-weight
      *ngIf="showWeight"
      class="plan-weight"
      [weightDataIsReady]="weightDataIsReady"
      [date]="calendarShared.selectedDate"
    ></app-plan-weight>
  </div>
</div>
